let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lU1wr"), load("29wqP"), load("lnKog")]).then(() => parcelRequire('2mcHd'));